export class IdName {

    public name: string;
    public id: string;

}
